import { useLocation } from 'react-router-dom';
import { useContext } from 'react';
import UserContext from './UserContext';
import TrainerHeader from './TrainerHeader';
import ConsultantHeader from './ConsultantHeader';

function ConditionalTrainerHeader() {
  const location = useLocation();
  const { session } = useContext(UserContext);
  
  const trainerServices = (session?.services && session.services.length > 0) ? session.services : (session?.service ? [session.service] : []);
  const servicePartnerTypes = session?.servicePartnerTypes || {};
  
  // Check if user has both instructor and consultant services
  const hasInstructorServices = trainerServices.some(service => 
    (servicePartnerTypes[service] || 'instructor') === 'instructor'
  );
  const hasConsultantServices = trainerServices.some(service => 
    (servicePartnerTypes[service] || 'instructor') === 'consultant'
  );
  
  // Consultant-specific routes (always use ConsultantHeader)
  const consultantRoutes = [
    '/trainer/consultant-dashboard',
    '/trainer/appointments'
  ];
  
  // Check if current route is consultant-specific
  const isConsultantRoute = consultantRoutes.some(route => 
    location.pathname.startsWith(route)
  );
  
  // Get active service to determine current context
  const activeService = localStorage.getItem('activeService') || trainerServices[0] || '';
  const activePartnerType = activeService ? (servicePartnerTypes[activeService] || 'instructor') : 'instructor';
  const isActiveServiceConsultant = activePartnerType === 'consultant';
  
  // Determine which header to show:
  // 1. If on consultant-specific route -> ConsultantHeader
  // 2. If user is consultant-only (no instructor services) -> ConsultantHeader for all routes
  // 3. If user has both services and active service is consultant -> ConsultantHeader
  // 4. Otherwise -> TrainerHeader
  if (isConsultantRoute || 
      (hasConsultantServices && !hasInstructorServices) || 
      (hasConsultantServices && hasInstructorServices && isActiveServiceConsultant)) {
    return <ConsultantHeader />;
  }
  
  return <TrainerHeader />;
}

export default ConditionalTrainerHeader;

